import React, { useEffect, useState } from "react";
import { Nav, NavItem, NavLink } from "reactstrap";

const NestedTabs = ({ activeTab, setActiveTab }) => {
  const [parentTab, setParentTab] = useState("teacher");

  const toggleParentTab = (tab) => {
    setParentTab(tab);
    if (tab === "teacher") setActiveTab("home");
    if (tab === "session") setActiveTab("voice");
    if (tab === "group") setActiveTab("Webinars");
  };

  useEffect(() => {
    if (["home", "about", "contact", "unitperformace"].includes(activeTab)) {
      setParentTab("teacher");
    } else if (["voice","Red Flag Sessions","Call Performance", "Insights"].includes(activeTab)) {
      setParentTab("session");
    } else if (
      ["Webinars", "Webinar Performance", "Webinar Insights"].includes(
        activeTab
      )
    ) {
      setParentTab("group");
    }
  }, [activeTab]);

  const toggleTab = (tab) => {
    setActiveTab(tab);
  };

  return (
    <div
      style={{
        backgroundColor: "white",
        // border: "1px solid #ffffff",
        borderRadius: "8px 8px 0 0",
        padding: "12px",
        // maxWidth: "700px",
        margin: "auto",
      }}
    >
      {/* Parent Tabs */}
      <Nav tabs className="mb-2" 
      // style={{ borderBottom: "2px solid #495057" }}
      >
        <NavItem>
          <NavLink
            className={parentTab === "teacher" ? "active" : ""}
            onClick={() => toggleParentTab("teacher")}
            style={{ cursor: "pointer", fontWeight: parentTab === "teacher" ? "800" : "" }}
          >
            Teacher Details
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={parentTab === "session" ? "active" : ""}
            onClick={() => toggleParentTab("session")}
            style={{ cursor: "pointer", fontWeight: parentTab === "session" ? "800" : "" }}
          >
            1-1 Session Analysis
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={parentTab === "group" ? "active" : ""}
            onClick={() => toggleParentTab("group")}
            style={{ cursor: "pointer", fontWeight: parentTab === "group" ? "800" : "" }}
          >
            Group Session Analysis
          </NavLink>
        </NavItem>
      </Nav>

      {/* Child Tabs */}
      <Nav
        tabs
        style={{
          marginLeft: "20px",
          borderBottom: "1px solid #ced4da",
          fontSize: "0.9rem",
          color: "#495057",
        }}
      >
        {parentTab === "teacher" && (
          <>
            <NavItem>
              <NavLink
                className={activeTab === "home" ? "active" : ""}
                onClick={() => toggleTab("home")}
                style={{ cursor: "pointer" }}
              >
                Performance KPIs
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={activeTab === "about" ? "active" : ""}
                onClick={() => toggleTab("about")}
                style={{ cursor: "pointer" }}
              >
                Student List
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={activeTab === "contact" ? "active" : ""}
                onClick={() => toggleTab("contact")}
                style={{ cursor: "pointer" }}
              >
                Compliance Feedback
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={activeTab === "unitperformace" ? "active" : ""}
                onClick={() => toggleTab("unitperformace")}
                style={{ cursor: "pointer" }}
              >
                Past Performance
              </NavLink>
            </NavItem>
          </>
        )}

        {parentTab === "session" && (
          <>
            <NavItem>
              <NavLink
                className={activeTab === "voice" ? "active" : ""}
                onClick={() => toggleTab("voice")}
                style={{ cursor: "pointer" }}
              >
                Sessions List
              </NavLink>
            </NavItem>
            {/* <NavItem>
             <NavLink
                className={activeTab === "Red Flag Sessions" ? "active" : ""}
                onClick={() => toggleTab("Red Flag Sessions")}
                style={{ cursor: "pointer" }}
              >
                Red-Flag Session Analysis
              </NavLink>
            </NavItem> */}
            <NavItem>
              <NavLink
                className={activeTab === "Call Performance" ? "active" : ""}
                onClick={() => toggleTab("Call Performance")}
                style={{ cursor: "pointer" }}
              >
               Key Metrics
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={activeTab === "Insights" ? "active" : ""}
                onClick={() => toggleTab("Insights")}
                style={{ cursor: "pointer" }}
              >
                Topic Insights
              </NavLink>
            </NavItem>
          </>
        )}

        {parentTab === "group" && (
          <>
            <NavItem>
              <NavLink
                className={activeTab === "Webinars" ? "active" : ""}
                onClick={() => toggleTab("Webinars")}
                style={{ cursor: "pointer" }}
              >
               Sessions List
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={activeTab === "Webinar Performance" ? "active" : ""}
                onClick={() => toggleTab("Webinar Performance")}
                style={{ cursor: "pointer" }}
              >
              Key Metrics
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={activeTab === "Webinar Insights" ? "active" : ""}
                onClick={() => toggleTab("Webinar Insights")}
                style={{ cursor: "pointer" }}
              >
                Webinar Insights
              </NavLink>
            </NavItem>
          </>
        )}
      </Nav>
    </div>
  );
};

export default NestedTabs;
